export const maintenanceIntegrityManagement = require('images/expertise/oil-gas/MaintenanceIntegrityManagement.webp');
export const oilGasHero = require('images/expertise/oil-gas/OilGasHero.webp');
export const pipelineTransmissionSystemsServices = require('images/expertise/oil-gas/PipelineTransmissionSystemsServices.webp');
